export const getContactDisplayName = (contact) => {
  if (!contact || typeof contact !== "object") return "";

  const firstName = String(
    contact.first_name
      || contact.firstName
      || contact.firstname
      || ""
  ).trim();
  const lastName = String(
    contact.last_name
      || contact.lastName
      || contact.lastname
      || ""
  ).trim();
  const combinedName = [firstName, lastName].filter(Boolean).join(" ");

  return String(
    combinedName
      || contact.name
      || contact.fullName
      || contact.displayName
      || contact.contactName
      || contact.email
      || ""
  ).trim();
};
